import type { JadeStrings } from "./tilecastle.vi.ts";

/** English twin of `tilecastle.vi.ts`. */
export const jadeEn: JadeStrings = {
  left: (n) => `${n} left`,
  goldLine: (n) => `Gold line ${n}`,
  stuck: "No way left! Undo a few steps or restart.",
  toThrone: "Every tile picked up! Off to the golden throne.",
  hintCost: "Using a hint caps this level at 2 stars. Still want it?",
  resultSatchel: (peak, tidiest) =>
    peak <= tidiest ? `Your satchel held ${peak} at most, as tidy as the best route!` : `Your satchel held ${peak} at most, the tidiest route needs only ${tidiest}.`,
  resultRule: (gold) => `Three stars when the satchel never passes the gold line of ${gold}, two stars when it goes one over.`,
  resultHint: "You used a hint, so 2 stars at most.",
};
